import React, { useEffect, useRef } from 'react'
import '../css/About.css'
import imagePersonal from '../images/CropImage.png'
import { gsap, Bounce } from 'gsap'
import Helmet from 'react-helmet'

function About({ setPathName }) {
    setPathName(window.location.pathname)
    const reference = useRef(null)
    useEffect(() => {
        gsap.from('.about-container h1', { y: -200, duration: 1.2, ease: Bounce.easeOut, opacity: 0 })
        gsap.from(reference.current, { x: '-50%', duration: 1.2, opacity: 0 })
        gsap.from('.large-pic, .small-pic', { duration: 0.5, opacity: 0, scale: 0.2 }).delay(1)
    }, [])
    return (
        <div className='about-container'>
            <Helmet>

                <title>Shakthi's Portfolio : About me</title>
                <meta name="description" content="Portfolio web site created by Shakthi Ganesh R, web and android app developer. 
                A student of SASTRA Deemed to be University." />
                <meta name="google-site-verification" content="Iw5fniSyefKh1MwUJCfIgMUX_5Avtj3MszSUm0CUBbI" />
                <meta itemprop="name" content="Shakthi's Portfolio" />
                <meta itemprop="description" content="Portfolio web site created by Shakthi Ganesh R, web and android app developer. 
                A student of SASTRA Deemed to be University." />
                <meta itemprop="image" content="https://shakthi-ganesh-r-portfolio.web.app/static/media/CropImage.0880ee6a.png" />

                <meta property="og:url" content="https://shakthi-ganesh-r-portfolio.web.app" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Shakthi's Portfolio" />
                <meta property="og:description" content="Portfolio web site created by Shakthi Ganesh R, web and android app developer.
                A student of SASTRA Deemed to be University." />
                <meta property="og:image" content="https://shakthi-ganesh-r-portfolio.web.app/static/media/CropImage.0880ee6a.png" />


                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Shakthi's Portfolio" />
                <meta name="twitter:description" content="Portfolio web site created by Shakthi Ganesh R, web and android app developer.
A student of SASTRA Deemed to be University." />
                <meta name="twitter:image" content="https://shakthi-ganesh-r-portfolio.web.app/static/media/CropImage.0880ee6a.png" />

            </Helmet>
            <div className='about-body'>
                <h1>
                    Wow, A whole page just about me!
                </h1>
                <h3>
                    Me talking about myself
                </h3>
                <img src={imagePersonal} className='small-pic' alt="Shakthi Ganesh R - portfolio"></img>
                <p ref={reference}>
                    Hey there! What's up, dear reader...
                    <br />
                    I am Shakthi Ganesh R, a passionate developer hailing from Aruppukottai, a town in Virudhunagar district, Tamil Nadu, India.<br />
                    I completed my primary and secondary schooling in St. Joseph Carmel Matriculation School, and in S.B.K Higher Secondary School, respectively. My higher education was in Biology and Mathematics at Noble Matriculation Higher Secondary School. Later, I joined SASTRA Deemed to be University, Thanjavur, Tamil Nadu to pursue my Bachelor's degree in Electronics and Communication Engineering. <br />
                    Till my first year, I had no idea as to what exactly programming was, as I was a biology student in my high school. In the first year of my engineering, I was exposed to C and C++ through my college curriculum. Subsequently, I made use of an opportunity to learn SaaS, using Ruby on Rails through an elective course. This triggered an interest in me to learn Web Development from which, this beautiful journey kickstarted. I made good use of the COVID -19 lockdowns to enhance and develop my skillset by learning Java, JavaScript, and Kotlin. Currently, I am a developer with sound knowledge of Web and Android App development.
                    <br />Kudos! you have wrapped up perusing my short story.
                </p>
            </div>
            <img src={imagePersonal} className='large-pic'></img>
        </div>
    )
}

export default About
